
import React from 'react';
import { Separator } from "../components/ui/separator";

const Legal = () => {
  return (
    <div className="container py-12 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-8">Rechtliche Informationen</h1>
      
      {/* Impressum Section */}
      <section className="mb-12">
        <h2 className="text-2xl font-bold mb-6">Impressum</h2>
        
        <div className="space-y-6">
          <div>
            <h3 className="font-bold mb-2">Verantwortlich für den Inhalt</h3>
            <p>Dietronik-Service e.K.</p>
            <p>Artur Dieter</p>
            <p>Hebelstraße 2</p>
            <p>78564 Wehingen</p>
            <p>Telefon: 074269649354</p>
            <p>Mobil: 01590/1293720</p>
            <p>E-Mail: info@dietronik-service.de</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">Urheberrechtsschutz</h3>
            <p>Auf dieser Website publizierten Materialien sind vom Urheberrecht geschützt. Die Weiterverwendung, Modifikation oder Weitergabe ist nur mit ausdrücklicher schriftlicher Zustimmung gestattet.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">Warenzeichen & Marken</h3>
            <p>OSRAM, PHILIPS, AVM, GIRA, Hager, ABB, Schneider Electric, KNX sowie alle anderen Produktbezeichnungen und Warenbezeichnungen von Hardware und Software sowie Firmennamen und Firmenlogos, die auf unserer Website genannt werden, sind in der Regel gleichzeitig auch eingetragene Warenzeichen oder Marken der jeweiligen Eigentümer und sind als solche zu betrachten.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">Urheberrecht</h3>
            <p>Falls nicht anders angegeben, unterliegen alle Seiten dieses Webangebotes dem Urheberrecht (Copyright). Dies gilt insbesondere für Texte, Bilder, Grafiken und Style-Dateien, einschließlich deren Anordnung auf den Websites.</p>
            <p className="mt-2">Eine Vervielfältigung oder Verwendung von Websites (oder von Teilen daraus) in anderen elektronischen oder gedruckten Publikationen und deren Veröffentlichung (auch im Internet) ist nur nach vorheriger Genehmigung gestattet.</p>
            <p className="mt-2">Weiterhin können Bilder, Grafiken, Text- oder sonstige Dateien ganz oder teilweise dem Urheberrecht Dritter unterliegen.</p>
            <p className="mt-2">Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund der bloßen Nennung in unserem Internetangebot ist nicht der Schluss zu ziehen, dass Markenzeichen nicht durch Rechte Dritter geschützt sind.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">Haftungsausschluss</h3>
            <p>Der Autor hat alle in seinem Bereich bereitgestellten Informationen nach bestem Wissen und Gewissen erarbeitet und geprüft. Jedoch übernimmt der Autor keinerlei Gewähr für die Aktualität, Korrektheit, Vollständigkeit oder Qualität der bereitgestellten Informationen. Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern seitens des Autors kein nachweislich vorsätzliches oder grob fahrlässiges Verschulden vorliegt.</p>
            <p className="mt-2">Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen.</p>
          </div>
        </div>
      </section>

      <Separator className="my-8" />

      {/* Datenschutz Section */}
      <section>
        <h2 className="text-2xl font-bold mb-6">Datenschutzerklärung</h2>
        
        <div className="space-y-6">
          <div>
            <h3 className="font-bold mb-2">1. Datenschutz auf einen Blick</h3>
            <p>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">2. Allgemeine Hinweise</h3>
            <p>Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">3. Datenerfassung auf unserer Website</h3>
            <h4 className="font-semibold mt-4 mb-2">Cookies</h4>
            <p>Unsere Website verwendet Cookies. Das sind kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.</p>
            
            <h4 className="font-semibold mt-4 mb-2">Google Analytics</h4>
            <p className="mb-2">
              Diese Website nutzt Google Analytics, einen Webanalysedienst der Google Ireland Limited („Google"). 
              Google Analytics verwendet sog. „Cookies", Textdateien, die auf Ihrem Computer gespeichert werden und 
              die eine Analyse der Benutzung der Website durch Sie ermöglichen.
            </p>
            <p className="mb-2">
              Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website (einschließlich Ihrer 
              gekürzten IP-Adresse) werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. 
              Wir nutzen Google Analytics mit der Erweiterung "_anonymizeIp()", wodurch IP-Adressen gekürzt verarbeitet werden, 
              sodass eine Personenbeziehbarkeit ausgeschlossen ist.
            </p>
            <p className="mb-2">
              Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die 
              Websiteaktivitäten für uns zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung 
              verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte 
              übertragen, sofern dies gesetzlich vorgeschrieben ist oder soweit Dritte diese Daten im Auftrag von Google 
              verarbeiten.
            </p>
            <p className="mb-2">
              Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; 
              wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser 
              Website vollumfänglich nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der Bearbeitung 
              der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten 
              Zweck einverstanden.
            </p>
            <p className="mb-2">
              Sie können der Datenerhebung und -speicherung durch Google Analytics jederzeit widersprechen. 
              Nähere Informationen hierzu finden Sie unter{' '}
              <a 
                href="https://tools.google.com/dlpage/gaoptout?hl=de" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-primary hover:underline"
              >
                https://tools.google.com/dlpage/gaoptout?hl=de
              </a>.
            </p>
            <p className="mb-2">
              <strong>Google Analytics Tag-ID:</strong> G-JHVD11VEZX
            </p>
            
            <h4 className="font-semibold mt-4 mb-2">Server-Log-Dateien</h4>
            <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Browsertyp und Browserversion</li>
              <li>Verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-2">4. Kontaktformular</h3>
            <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
          </div>

          <div>
            <h3 className="font-bold mb-2">5. Ihre Rechte</h3>
            <p>Sie haben jederzeit das Recht:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>Auskunft über Ihre bei uns gespeicherten Daten zu erhalten</li>
              <li>Diese berichtigen zu lassen</li>
              <li>Die Löschung oder Sperrung Ihrer Daten zu verlangen</li>
              <li>Der Datenverarbeitung zu widersprechen</li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold mb-2">6. Änderung unserer Datenschutzbestimmungen</h3>
            <p>Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Legal;
